import geometry from '../../../scene/util/geometry';
import { isFixedRoom } from '../../../util/room';

export function adjustMountingRailChainPos(chain, newX, wallWidth) {
  chain[0].x = isFixedRoom() ? Math.max(0, newX) : newX;
  for (let i = 1; i < chain.length; i++) {
    chain[i].x = chain[i - 1].x + chain[i - 1].width;
  }

  if (
    isFixedRoom() &&
    chain[chain.length - 1].x + chain[chain.length - 1].width > wallWidth
  ) {
    for (let i = chain.length - 1; i >= 0; i--) {
      if (i === chain.length - 1) {
        chain[i].x = wallWidth - chain[i].width;
      } else {
        chain[i].x = chain[i + 1].x - chain[i].width;
      }
    }
  }
}

function getMountingRailChain(current, mountingRails, padding, chain = []) {
  for (let i = 0; i < mountingRails.length; i++) {
    if (geometry.collides(current, mountingRails[i], padding)) {
      const newCurrent = mountingRails[i];
      chain.push(newCurrent);
      mountingRails.splice(i, 1);

      return getMountingRailChain(newCurrent, mountingRails, padding, chain);
    }
  }

  return chain;
}

export function getMountingRailChains(mountingRails, padding = {}, done = []) {
  mountingRails = mountingRails.slice();
  if (!mountingRails.length) return done;

  const group = [];

  const current = mountingRails.pop();
  group.push(current);

  const mountingRailChain = getMountingRailChain(
    current,
    mountingRails,
    padding
  );
  group.push(...mountingRailChain);
  done.push(group);

  return getMountingRailChains(mountingRails, padding, done);
}
